import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { COLUMNS } from "./orderColumn"
import { getDynamicdata, transactionRegistration, updateDynamicData } from "../../../services/services";
import { decrypt } from "../../../utils/encodingdecoding";
import { getAllCustomer } from "../../../services/auth";
import Paginated from "../../partial/Paginated";
import { getDate } from "../../../utils/helper";

const CustomerOrder = () => {
    const [loader, setLoader] = useState(false);
    const [order, setOrder] = useState([])
    const [data, setData] = useState([]);
    const [openRow, setOpenRow] = useState(null);
    const [selectedUserType, setSelectedUserType] = useState("all");
    const [userOpt, setUserOpt] = useState([])
    const [selectedUser, setSelectedUser] = useState("all")
    const [customerList, setCustomerList] = useState([])
    const [selectedState, setSelectedState] = useState("all");
    const [orderCount, setOrderCount] = useState();
    const id = decrypt(localStorage.getItem("Id"))

    useEffect(() => {
        const fetch = async () => {
            setLoader(true);
            let tempToken = JSON.parse(localStorage.getItem("token_gen"));
            tempToken = tempToken?.access_token;
            const id = localStorage.getItem("Id");
            const res = await getDynamicdata(tempToken?.access_token, selectedState === "all" ? "" : "requestData.outlet.state", selectedState === "all" ? "" : selectedState?.toUpperCase(), 1, 50);
            if (res.message === "Success") {
                if (Array.isArray(res?.data) && res?.data?.length > 0) {
                    setOrder(res?.data)
                    setOrderCount(res?.totalCount)
                } else {
                    setData([])
                    setOrder([])
                    setOrderCount(0)
                }

            }
            setLoader(false)
        };
        if (selectedState) {
            fetch();
        }

    }, [selectedState]);


    useEffect(() => {
        if (customerList.length) return;

        const fetchCustomerList = async () => {
            setLoader(true);

            let tempToken = JSON.parse(localStorage.getItem("token_gen"));
            tempToken = tempToken?.access_token;
            const id = localStorage.getItem("Id");

            const res = await getAllCustomer(tempToken, id, "", "", "");

            if (res?.message === "success") {
                setCustomerList(res?.data?.data || []);
            }

            setLoader(false);
        };

        // fetchCustomerList();
    }, []);

    useEffect(() => {
        if (!customerList.length) return;

        if (selectedUserType === "all") {
            setUserOpt([]);
            return;
        }

        const options = customerList
            .filter((ele) => {
                return ele?.customerData?.customerType === selectedUserType;
            })
            .map((ele) => ({
                label: ele.customerData?.name,
                value: ele.customerData?.mobile,
                type: ele.customerData?.customerType,
            }));

        setUserOpt([
            { label: "Select All", value: "" },
            ...options,
        ]);

    }, [customerList, selectedUserType]);


    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "approved":
                return "text-success";
            case "accepted":
                return "text-success";
            case "rejected":
                return "text-danger";
            default:
                return "text-warning";
        }
    };

    const handleOrderAction = async (ele, status) => {
        const temp = {
            ...ele,
            requestData: {
                ...ele.requestData,
                order_status: status,
            },
        };
        setLoader(true);
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const res = await updateDynamicData(tempToken?.access_token, temp)
        if (res.message === "Success") {

            if (status === "Accepted") {
                const transBody = {
                    amount: ele?.requestData?.netValue,
                    userType: "Wholesaler",
                    mobile: ele?.requestData?.outlet?.ownersNo,
                    schemacode: "TSC002032",
                    orderDetails: ele?.requestData
                }
                await transactionRegistration(
                    tempToken?.access_token,
                    JSON.stringify(transBody)
                );
            }

            setOrder((prevData) =>
                prevData.map((item) => {
                    if (item === ele) {
                        return {
                            ...item,
                            requestData: {
                                ...item.requestData,
                                order_status: status,
                            },
                        };
                    }
                    return item;
                })
            );
        }
        setLoader(false);
    };

    useEffect(() => {
        if (order?.length > 0) {
            const filteredOrders = filterOrders(order);
            const tempData = filteredOrders.map((ele, index) => {
                return {
                    ...ele,
                    searchText: `
                                ${ele?.requestData?.distributorname || ""}
                                ${ele?.requestData?.distributormobile || ""}
                                ${ele?.requestData?.employeeName || ""}
                                ${ele?.requestData?.employeePhoneNumber || ""}
                                ${ele?.requestData?.order_status || "Pending"}
                                ${ele?.requestData?.beatName || ""}
                                ${ele?.requestData?.beatERPId || ""}
                                ${ele?.requestData?.outlet?.ownersName || ""}
                                ${ele?.requestData?.outlet?.ownersNo || ""}
                                ${ele?.requestData?.netValue || ""}
                                ${ele?.requestData?.orderInUnits || ""}
                                ${ele?.requestData?.outlet?.address}
                                ${ele?.requestData?.outlet?.city}
                                `.toLowerCase(),
                    callEndTime: getDate(ele?.requestData?.callEndTime, "DD-MM-YYYY hh:mm:ss"),
                    distributor: <>
                        {ele?.requestData?.distributorname}<br />
                        {ele?.requestData?.distributormobile}
                    </>,
                    order_status: (
                        <div className="d-flex flex-column align-items-start gap-1">
                            <span className={getStatusColor(ele?.requestData?.order_status)}>
                                {ele?.requestData?.order_status ? ele?.requestData?.order_status === "Approved" ? "Accepted" : ele?.requestData?.order_status : "Pending"}
                            </span>
                            {!ele?.requestData?.order_status && (
                                <div className="d-flex gap-2 mt-1">
                                    <button
                                        className="btn btn-sm btn-success"
                                        onClick={() => handleOrderAction(ele, "Accepted")}
                                    >
                                        Accept
                                    </button>

                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleOrderAction(ele, "Rejected")}
                                    >
                                        Reject
                                    </button>
                                </div>
                            )}
                        </div>
                    ),
                    salesassociate: (
                        <>
                            {ele?.requestData?.employeeName}<br />
                            {ele?.requestData?.employeePhoneNumber}
                        </>
                    ),
                    orderdetails: (
                        <div style={{ minWidth: "350px", display: "block" }}>
                            <div className="d-flex flex-column align-items-start">
                                <div className="text-break">
                                    <span className="fw-bold">Beat name: </span>{ele?.requestData?.beatName}
                                </div>

                                <div className="text-break">
                                    <span className="fw-bold">Beat Id: </span>{ele?.requestData?.beatErpId}
                                </div>

                                <div className="text-break">
                                    <span className="fw-bold">Wholesaler name: </span>{ele?.requestData?.outlet?.ownersName}
                                </div>

                                <div className="text-break">
                                    <span className="fw-bold">Contact no: </span>{ele?.requestData?.outlet?.ownersNo}
                                </div>

                                <div className="text-break">
                                    <span className="fw-bold">Value: </span>{ele?.requestData?.netValue}
                                </div>

                                <div className="text-break">
                                    <span className="fw-bold">Order units: </span>{ele?.requestData?.orderInUnits}
                                </div>
                                <div className="text-break">
                                    <span className="fw-bold">Address: </span>
                                    {ele?.requestData?.outlet?.address}, {ele?.requestData?.outlet?.city}, {ele?.requestData?.outlet?.state}, {ele?.requestData?.outlet?.pinCode}
                                </div>
                            </div>

                            <div className="product_box">
                                <div className="product_box_header">
                                    <h3 onClick={() => setOpenRow((prev) => (prev !== index ? index : null))} className={openRow === index ? "active" : ""}>Product Details</h3>
                                </div>
                                {<div className={`product_box_body  ${openRow === index ? "active" : ""}`}>
                                    <table
                                        className="table table-bordered table-striped"
                                        style={{ fontSize: "12px", marginBottom: 0 }}
                                    >
                                        <thead>
                                            <tr>
                                                <th style={{ padding: "4px" }}>Product Name</th>
                                                <th style={{ padding: "4px" }}>Quantity</th>
                                                <th style={{ padding: "4px" }}>Price</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {ele?.requestData?.sales?.length > 0 ? ele?.requestData?.sales?.map((prod, i) => (
                                                <tr key={i}>
                                                    <td style={{ padding: "4px" }}>{prod?.productName}</td>
                                                    <td style={{ padding: "4px" }}>{prod?.quantity}</td>
                                                    <td style={{ padding: "4px" }}>{prod?.price}</td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan="3" style={{ textAlign: "center", padding: "8px", fontWeight: "600" }}>
                                                    No record found
                                                </td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                </div>}

                            </div>
                        </div >
                    )
                };
            });
            setData(tempData?.length ? tempData.reverse() : []);
        }
    }, [order, selectedUserType, selectedUser, userOpt, openRow]);

    useEffect(() => {
        setSelectedUser("");
    }, [selectedUserType]);

    const filterOrders = (orders) => {

        if (!selectedUserType || selectedUserType === "all") {
            return orders;
        }

        if (selectedUser) {
            return orders.filter((ele) => {
                const rd = ele?.requestData;

                switch (selectedUserType) {
                    case "Distributor":
                        return rd?.distributormobile === selectedUser;

                    case "Wholesaler":
                        return rd?.outlet?.ownersNo === selectedUser;

                    case "Sales":
                        return rd?.employeePhoneNumber === selectedUser;

                    default:
                        return true;
                }
            });
        }

        const allowedMobiles = userOpt
            .filter((u) => u.type === selectedUserType)
            .map((u) => u.value);

        return orders.filter((ele) => {
            const rd = ele?.requestData;

            switch (selectedUserType) {
                case "Distributor":
                    return allowedMobiles.includes(rd?.distributormobile);

                case "Wholesaler":
                    return allowedMobiles.includes(rd?.outlet?.ownersNo);

                case "Sales":
                    return allowedMobiles.includes(rd?.employeePhoneNumber);

                default:
                    return true;
            }
        });
    };

    const generateCSV = async () => {
        setLoader(true);

        try {
            const token = JSON.parse(localStorage.getItem("token_gen"));

            if (!token?.access_token || !id) {
                throw new Error("Missing token or ID");
            }
            const res = await getDynamicdata(token?.access_token, selectedState === "all" ? "" : "requestData.outlet.state", selectedState === "all" ? "" : selectedState?.toUpperCase(), "", "");
            let tempData
            if (res.message === "Success") {
                if (Array.isArray(res?.data) && res?.data?.length > 0) {
                    const data = res?.data || [];
                    tempData = data?.map((val) => {
                        return {
                            order: val?.requestData?.callEndTime
                                ? `${getDate(val.requestData.callEndTime, "DD-MM-YYYY hh:mm:ss")}`
                                : "",
                            state: val?.requestData?.outlet?.state,
                            distributorName: val?.requestData?.distributorname,
                            distributorContactNo: `${val?.requestData?.distributormobile}`,
                            salesAssociate: val?.requestData?.employeeName,
                            beatName: val?.requestData?.beatName,
                            beatId: val?.requestData?.beatErpId,
                            wholesalerName: val?.requestData?.outlet?.ownersName,
                            wholesalerContactNo: `${val?.requestData?.outlet?.ownersNo}`,
                            value: `${val?.requestData?.netValue}`,
                            orderUnits: `${val?.requestData?.orderInUnits}`,
                            address: `"${val?.requestData?.outlet?.address}, ${val?.requestData?.outlet?.city}, ${val?.requestData?.outlet?.state}, ${val?.requestData?.outlet?.pinCode}"`,
                            orderStatus: val?.requestData?.order_status || "Pending"
                        };
                    });
                }
            }


            const csvHeaders = [
                "Order",
                "State",
                "Distributor name",
                "Distributor contact no",
                "Sales Associate",
                "Beat name",
                "Beat Id",
                "Wholesaler name",
                "Wholesaler Contact no",
                "Value",
                "Order units",
                "Address",
                "Order Status"
            ];
            const csvData = [
                csvHeaders,
                ...tempData?.map((row) => [
                    row.order,
                    row.state,
                    row.distributorName,
                    row.distributorContactNo,
                    row.salesAssociate,
                    row.beatName,
                    row.beatId,
                    row.wholesalerName,
                    row.wholesalerContactNo,
                    row.value,
                    row.orderUnits,
                    row.address,
                    row.orderStatus
                ]),
            ];
            const csvContent =
                "data:text/csv;charset=utf-8," +
                csvData.map((row) => row.join(",")).join("\n");
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "report.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error generating CSV:", error.message || error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"Customer Orders"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Orders Details</h4>
                            </div>
                            <div className="dashboard__right">
                                <button onClick={() => generateCSV()} className="btn btn-default">
                                    <i
                                        class="fa-solid fa-download"
                                        style={{ marginRight: "10px" }}
                                    ></i>
                                    Download Orders
                                </button>
                            </div>
                        </div>
                        <div className="dashboard__body">
                            <Paginated
                                data={data || []}
                                columns={COLUMNS}
                                selectedState={selectedState}
                                setSelectedState={setSelectedState}
                                orderCount={orderCount}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



export default CustomerOrder